<template>
  <div v-if="showDetails">
    <!-- <div id='overlay' @click='$emit("close-details")'></div> -->
    <div id="details">
      <header id="header" class="row">
        <div :class="`col-xs-12 monit-item bg-${statusColor}`">
          <h5 class="mb-0 pt-1">{{ Object.keys(item).length && item.NAME }}</h5>
          <div class="update"><clock-icon title="" /> {{ updated }}</div>
        </div>
        <div
          :class="`col-xs-6 monit-tabs ${active == 'info' ? 'active' : ''}`"
          @click="selectDetails(0)"
        >
          Informações
        </div>
        <div
          :class="`col-xs-6 monit-tabs ${active == 'charts' ? 'active' : ''}`"
          @click="selectDetails(1)"
        >
          Gráficos
        </div>
      </header>
      <div class="column details-area  pl-2 pr-2">
        <div class="col-xs-12 content" v-if="active == 'info'">
          <div class="info-title">Medições</div>
          <div class="col-xs-12 info-details">
            <div
              class="measures"
              v-for="measure in item.MEASURES"
              :key="measure.POS"
            >
              <strong>{{ measure.TYPE }}</strong>
              <h6 :style="'color:' + measureStatusColor(measure.STATUS) + ';'">
                {{ measure.VALUE }} {{ measure.UNIT }}
              </h6>
            </div>
          </div>
          <div class="info-title">Detalhes</div>
          <div class="col-xs-12 info-details">
            <strong>Modelo:</strong> {{ item.MODEL }}<br />
            <span v-if="item.INTERFACE"
              ><strong>Interface:</strong> {{ item.INTERFACE }}<br
            /></span>
            <strong>Dispositivo:</strong> {{ item.DIR }}<br />
            <span v-if="item.NOTE"
              ><strong>Observação:</strong> {{ item.NOTE }}<br
            /></span>
            <div v-if="item.GENERIC">
              <span v-for="(g, i) in item.GENERIC" :key="i">
                <strong>{{ g.NAME }}</strong> {{ g.VALUE }}<br />
              </span>
            </div>
          </div>

          <b-button
          v-if="'INPUTS' in item && item.INPUTS.length"
            class="col-12 mt-3"
            variant="outline-secondary"
            rounded
            pill
            @click="visible = !visible"
            size="sm"
            :aria-expanded="visible ? 'true' : 'false'"
            :class="visible ? null : 'collapsed'"
          >
            {{
              visible
                ? "Ocultar comandos do sensor"
                : "Exibir comandos do sensor"
            }}
          </b-button>
          <b-collapse id="collapse-4" class="mb-1" v-model="visible" v-if="'INPUTS' in item && item.INPUTS.length">
            <p class="warning-command mt-3">
              <alert-icon /> Utilize os comandos do sensor com cuidado.
            </p>

            <div class="mb-4 mt-4">
              <div
                v-for="button in item.BUTTONS"
                :key="button.name"
                class="buttons"
              >
                <b-button
                  variant="3v3"
                  block
                  @click="buttons(button.COMMAND)"
                  size="sm"
                >
                  {{ button.NAME }}
                </b-button>
              </div>
            </div>
            <!-- COMMANDS -->
            <div class="middle-xs mb-1 mt-1 container-command">
              <b-input-group
                class="command-button row mr-0 ml-0 p-0"
                v-for="(btn, i) in listButtons"
                :key="i"
              >
                <label :for="`field-${i}`" class="label col-12 p-0 mb-1"
                  >{{ btn.LABEL }}:</label
                >

                <b-form-input
                  :id="`field-${i}`"
                  type="text"
                  placeholder="Digite o comando"
                  class="col-10"
                  ref="input"
                  size="sm"
                />
                <b-input-group-append>
                  <!-- squared -->
                  <b-button
                    :variant="item.MANUAL ? 'orange' : '3v3'"
                    block
                    class="cmd-button"
                    @click="sendButton(i, btn)"
                    rounded
                    size="sm"
                  >
                    ENVIAR
                  </b-button>
                </b-input-group-append>
                <div
                  v-if="btn.STATUS !== ''"
                  class="obs-info col-12 text-left p-1 mt-1 status"
                >
                  {{ btn.STATUS }}
                </div>
              </b-input-group>
            </div>
          </b-collapse>
        </div>
        <div class="col-xs-12 content chart" v-else>
          <sensorChart
            eqp="SENSOR"
            :name="item.NAME"
            :columns="item.MEASURES"
            :col-names="listOptionsChart"
            :items="item"
          />
        </div>
      </div>
      <footer id="footer">
        <b-btn
          size="sm"
          block
          @click="$emit('close-details')"
          :class="`close-button bg-${statusColor}`"
        >
          Fechar
        </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import { cmd } from "@/api";
import sensorChart from "@/pages/monitoringPages/Sensors/components/SensorCharts";
export default {
  name: "sensor-details",
  components: {
    sensorChart
  },
  props: {
    isMobile: Boolean,
    item: Object,
    statusColor: String,
    updated: String,
    ending: String,
    showDetails: Boolean
  },
  data() {
    return {
      active: "info",
      visible: false
    };
  },
  watch: {
    showDetails(newValue, oldValue) {
      if (!newValue && oldValue) this.active = "info";
    },
    item(newValue, oldValue) {
      if (Object.keys(newValue).length && newValue.ID != oldValue.ID)
        this.active = "info";
    },
    isMobile() {
      this.showDetailsActuators(this.active);
    },
    active(newValue, oldValue) {
      this.showDetailsActuators(newValue);
    },
    active(newValue, oldValue) {
      this.showDetailsActuators(newValue);
    }
  },
  methods: {
    showDetailsActuators(active) {
      let details = document.getElementById("details");
      let header = document.getElementById("header");
      let footer = document.getElementById("footer");
      if (active == "info") {
        let width = this.isMobile ? "100%" : "361px";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      } else if (active == "charts") {
        let width = this.isMobile ? "100%" : "calc(100% - 51px)";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      }
    },
    selectDetails(idx) {
      let tabs = ["info", "charts"];
      this.active = tabs[idx];
    },
    sendButton(i, btn) {
      let newCMD = btn.CMD.concat(" ", this.$refs.input[i].$el.value);

      this.buttons(newCMD);
    },
    getResFw(file) {
      setTimeout((_) => {
        cmd
          .resfw(file)
          .then((ret) => {
            if (ret.status) {
              wait.hide();
              if (ret.value == "0") console.log("Sucesso na solicitação");
              else console.log("Falha na soliticação");
            } else {
              if (this.errFwRes < 5) {
                this.errFwRes++;
                console.log(
                  `Erro ao tentar ler arquivo. Tentativa: ${this.errFwRes}`
                );
                this.getResFw(file);
              } else {
                wait.hide();
                console.log("Falha na solicitação");
              }
            }
          })
          .catch((err) => {
            console.log(err);
            wait.hide();
          });
      }, 2000);
    },
    buttons(command) {
      let SET = true;
      let CMD = command;
      let data = { SET, CMD };
      this.changeProp(data, "reqofw");
    },
    changeProp(data, apiFunction) {
      data.ITEM = this.item.ID;
      wait.show();
      cmd[apiFunction](data)
        .then((ret) => {
          if (ret.status) {
            let FILE = ret.value;
            this.getResFw({ FILE });
          } else {
            console.log(ret.log);
            wait.hide();
          }
        })
        .catch((err) => {
          console.log(err);
          wait.hide();
        });
    },
    measureStatusColor(status) {
      switch (status) {
        case "low":
          return "#F44336";
        case "high":
          return "#FFAB00";
        case "ok":
          return "#7AB648";
        default:
          return "#999";
      }
    }
  },
  computed: {
    listOptionsChart() {
      let options = this.item.MEASURES.map(e => e.UNIT).filter(
        (e, i, arr) => arr.indexOf(e) == i
      );
      return options;
    },
    listButtons() {
      return this.item.INPUTS;
    }
  }
};
</script>

<style scoped>
.close-button {
  border: none;
  width: 100%;
  border-radius: 4px;
  color: #ffff;
  outline: none;
}
.close-button:hover {
  filter: contrast(80%);
}
.buttons {
  margin-top: 5px;
}
.container-command div + div {
  margin-top: 6px;
}
.warning-command {
  font-size: 0.8em;
  color: #616161;
  margin-bottom: 0px;
  padding: 8px;
  background-color: #f5f7a593;
  border-radius: 4px;
}
.warning-command .material-design-icon {
  font-size: 0.9em !important;
}
.container-command .cmd-button {
  margin-right: 0px;
}
.label {
  padding: 0;
  font-size: 0.8em;
  /* margin: 0; */
}
.status {
  background: #d0ddcca6;
  border-radius: 4px;
}
.obs-info {
  text-align: center;
  font-size: 0.68em;
}
</style>
